import { BrandType, ResponseType } from '@/types';
import { get, post, put } from './baseAxios';
import { API_BRAND } from './urls';

const url = API_BRAND;

const create = (request: BrandType): Promise<ResponseType<BrandType>> => post(`${url}`, request);

const update = (id: number, request: BrandType): Promise<ResponseType<BrandType>> =>
  put(`${url}/${id}`, request);

const getByUser = (): Promise<ResponseType<BrandType | null>> => get(`${url}`);

const checkAlias = (alias: string, excludedIds: number[] = []): Promise<ResponseType<boolean>> => {
  return get(`${url}/check-alias`, {
    params: { alias, excludedIds: excludedIds.join(',') },
  });
};

export { create, getByUser, update, checkAlias };
